<template>
  <v-icon>
    {{ svgPath }}
  </v-icon>
</template>

<script>
import { mdiChevronRight } from "@mdi/js";
export default {
  name: "MdiChevronRight",
  data() {
    return {
      svgPath: mdiChevronRight,
    };
  },
};
</script>
